import { Inject, Injectable } from '@angular/core';

import { L10nBase } from '@skylab-shared/core';

import { L10n } from '@skylab-angular-shared/core';
import { ServiceGridColumn } from '@skylab-angular-shared/ui';
import { FiscalDevicePaymentMethodsParametersMappingModelWrapper } from '../../fiscal-device-dialog-grid-item';

export type FiscalDeviceDialogPaymentMethodDirectGridColumnIdentitiy = 'paymentMethod' | 'mapped';
export type FiscalDeviceDialogPaymentMethodDirectGridCustomTemplates = 'fiscalDeviceDialogGridMappedPaymentMethod';

@Injectable({
    providedIn: 'root'
})
export class FiscalDeviceDialogPaymentMethodDirectGridService {

    public constructor(
        @Inject(L10n) private readonly l10n: L10nBase
    ) {}

    public getGridColumns(): ServiceGridColumn<FiscalDeviceDialogPaymentMethodDirectGridColumnIdentitiy, unknown, FiscalDevicePaymentMethodsParametersMappingModelWrapper, unknown, FiscalDeviceDialogPaymentMethodDirectGridCustomTemplates>[] {
        return [
            {
                header: this.l10n._T('scenes.configuration.shared.fiscalization.dialog.grid.columns.system-payment-method.title'),
                identityName: 'paymentMethod',
                columnDef: 'paymentMethod',
                width: '150px',
                cell: entity => entity.paymentMethodName,
                isResizable: false,
                isMovable: false,
                fillingColumn: true,
            },
            {
                header: this.l10n._T('scenes.configuration.shared.fiscalization.dialog.grid.columns.mapped-payment-method.title'),
                identityName: 'mapped',
                columnDef: 'mapped',
                width: '150px',
                template: 'fiscalDeviceDialogGridMappedPaymentMethod',
                isResizable: false,
                isMovable: false,
            },
        ];
    }
}
